// extracted by mini-css-extract-plugin
export default {"promoTypeWrapper":"form-content_promoTypeWrapper__8MmYj","limitedCountWrapper":"form-content_limitedCountWrapper__tNyH2","select":"form-content_select__UalFV"};